var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeviceTransfer = function SvgDeviceTransfer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3h10v2H3v11h6v2H1V3zm12 7h8v13H13V10zm0 2v9h6v-9zM5 20h5v2H5zM16 1l5 5-5 5V7H8V5h8z"
  })));
};
export default SvgDeviceTransfer;